import { IconArrowUp, IconPlayerStopFilled } from '@tabler/icons-react';
import { motion } from 'motion/react';

import { cn } from '@/utils/tailwind';

export type SearchButtonMode = 'submit' | 'stop' | 'disabled';

interface SearchButtonProps {
  mode: SearchButtonMode;
  onStop?: () => void;
}

const SearchButton: React.FC<SearchButtonProps> = ({ mode, onStop }) => {
  const isStop = mode === 'stop';
  const isSubmit = mode === 'submit';
  const isDisabled = mode === 'disabled';

  return (
    <motion.button
      type={isStop ? 'button' : 'submit'}
      onClick={isStop ? onStop : undefined}
      animate={{ scale: isDisabled ? 0.9 : 1 }}
      whileHover={!isDisabled ? { scale: 1.05 } : undefined}
      whileTap={!isDisabled ? { scale: 0.95 } : undefined}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      className={cn('cursor-pointer rounded-lg p-1.5! transition-colors', {
        'bg-secondary-base hover:bg-secondary-hover': isSubmit || isStop,
        'bg-disabled-strong': isDisabled,
      })}
      disabled={isDisabled}
    >
      {isStop ? (
        <IconPlayerStopFilled className="text-secondary-contrast" size={22} />
      ) : (
        <IconArrowUp
          className={cn('transition-colors', {
            'text-secondary-contrast': isSubmit,
            'text-disabled-contrast': isDisabled,
          })}
          size={22}
        />
      )}
    </motion.button>
  );
};

export default SearchButton;
